import React, { useEffect, useState } from 'react';
import { useToggle, useFetch } from 'hooks';
import LESSON_STATES from 'constants/lesson_states';
import { routes } from 'constants/config';
import FeatureFlag from 'components/shared/FeatureFlag';
import DateFormat from 'constants/date_format';
import LessonVersionModalContainer from '../VersionModal/LessonVersionModalContainer';

const DateSection = ({ title, data }) => {
  if (!data) {
    return null;
  }
  const { authorName } = data;
  const momentDate = data.timestamp ? moment(data.timestamp) : null;
  return (
    <>
      {momentDate && (
        <div className="d-f fd-c LessonOverviewLayout-dataSection">
          <span className="fw-b lh-24 fz-16 pb-4 c-brand-night">{title}</span>
          <span className="fz-14 lh-20">
            {momentDate.format(DateFormat.SHORT_AT_TIME)}
          </span>
          {authorName && (
            <span className="fz-14 lh-20">
              <span>{t('lesson_overview.by_author', { authorName })}</span>
            </span>
          )}
        </div>
      )}
    </>
  );
};

const LessonDatesSection = ({ lesson }) => {
  const [historyModalToggle, toggleHistoryModal] = useToggle();
  const isDraft = lesson.state === LESSON_STATES.DRAFT;
  const isScorm = lesson.scorm;
  const hasVersions = lesson.versionId != null;
  const currentVersion =
    lesson.currentVersion != null ? lesson.currentVersion.version : null;

  const [lessonVersionState, setLessonVersionState] = useState({
    versions: [],
    page: 1,
    totalVersions: 0,
  });

  const { data, loading, error } = useFetch(
    `${routes.VERSIONS.INDEX(lesson.id)}?page=${lessonVersionState.page}`,
  );

  useEffect(() => {
    if (!loading && !error) {
      setLessonVersionState(prevState => ({
        ...prevState,
        versions: [...prevState.versions, ...data?.versions?.data].sort(
          (a, b) => b.version - a.version,
        ),
        totalVersions: data?.versions?.totalVersions,
      }));
    }
  }, [data, error, loading, setLessonVersionState]);

  return (
    <div className="d-f">
      <DateSection
        title={t('lesson_overview.created')}
        data={lesson.createdAt ? lesson.createdAt : null}
      />
      <DateSection
        title={t('lesson_overview.last_published')}
        data={lesson.lastPublished ? lesson.lastPublished : null}
      />
      <DateSection
        title={
          lesson.state === 'new_version_pending'
            ? t('lesson_overview.last_edited_unpublished')
            : t('lesson_overview.last_edited')
        }
        data={lesson.lastEdited ? lesson.lastEdited : null}
      />
      <DateSection
        title={t('lesson_overview.archived')}
        data={lesson.archivedAt ? lesson.archivedAt : null}
      />
      <FeatureFlag>
        {!isScorm && !isDraft && hasVersions && (
          <div className="d-f fd-c LessonOverviewLayout-dataSection">
            <span className="fw-b lh-24 fz-16 pb-4 c-brand-night">
              {t('versions.version_with_number', {
                version_number: currentVersion,
              })}
            </span>
            <button
              className="u-linkBtn fz-14 lh-20"
              type="button"
              onClick={() => toggleHistoryModal()}
            >
              {t('lesson_overview.version_history')}
            </button>
          </div>
        )}
      </FeatureFlag>
      {historyModalToggle && hasVersions && (
        <LessonVersionModalContainer
          closeModal={() => toggleHistoryModal()}
          lessonId={lesson.id}
          isScormLesson={isScorm}
          setLessonVersionState={setLessonVersionState}
          {...lessonVersionState}
        />
      )}
    </div>
  );
};

export default props => <LessonDatesSection {...props} />;
